(function () {
  var KEY = 'hv_cart_expiry';
  var DURATION = 10 * 60 * 1000;
  var tickId = null;
  var observer = null;
  var injectScheduled = false;

  var CSS = [
    '#hv-good-choice {',
      'width: 100%;',
      'background: #006039;',
      'padding: 10px 24px;',
      'display: flex;',
      'align-items: center;',
      'justify-content: center;',
      'gap: 10px;',
      'box-sizing: border-box;',
    '}',
    '#hv-good-choice-icon {',
      'flex-shrink: 0;',
      'width: 23.1px;',
      'height: 23.1px;',
      'color: #ffffff;',
    '}',
    '#hv-good-choice-text {',
      'font-size: 15.4px;',
      'line-height: 1.25;',
      'color: #ffffff;',
      'font-family: inherit;',
      'font-weight: 500;',
      'text-align: center;',
    '}',

    '#hv-guarantee-bar {',
      'width: 100%;',
      'background: #000000;',
      'padding: 7px 24px;',
      'display: flex;',
      'align-items: center;',
      'justify-content: center;',
      'gap: 8px;',
      'box-sizing: border-box;',
    '}',
    '#hv-guarantee-icon {',
      'flex-shrink: 0;',
      'width: 15px;',
      'height: 15px;',
      'color: #ffffff;',
    '}',
    '#hv-guarantee-text {',
      'font-size: 13px;',
      'line-height: 1.25;',
      'color: #ffffff;',
      'font-family: inherit;',
      'font-weight: 600;',
      'text-align: center;',
      'letter-spacing: 0;',
      'white-space: nowrap;',
    '}',

    '#hv-timer-wrap {',
      'width: calc(100% - 48px);',
      'margin: 5px 24px 15px;',
      'font-family: inherit;',
      'display: block;',
    '}',
    '#hv-timer-box {',
      'position: relative;',
      'overflow: hidden;',
      'border-radius: 12px;',
      'padding: 13px 17px 11px;',
      'background: linear-gradient(135deg, #f4f4f4 0%, #e9e9e9 100%);',
      'box-shadow: 0 3px 14px rgba(0,0,0,0.08), inset 0 1px 0 rgba(255,255,255,0.9);',
      'border: 1px solid rgba(0,0,0,0.06);',
    '}',
    '#hv-timer-box::before {',
      'content: "";',
      'position: absolute;',
      'inset: 0;',
      'background: radial-gradient(ellipse at 10% 0%, rgba(255,255,255,0.75) 0%, transparent 65%);',
      'pointer-events: none;',
    '}',
    '#hv-timer-row {',
      'display: flex;',
      'align-items: center;',
      'justify-content: space-between;',
      'gap: 10px;',
      'margin-bottom: 8px;',
      'position: relative;',
      'z-index: 1;',
    '}',
    '#hv-timer-texts {',
      'display: flex;',
      'flex-direction: column;',
      'gap: 2px;',
      'min-width: 0;',
    '}',
    '#hv-timer-eyebrow {',
      'font-size: 10px;',
      'font-weight: 700;',
      'letter-spacing: 0.12em;',
      'text-transform: uppercase;',
      'color: rgba(0,0,0,0.48);',
      'white-space: nowrap;',
    '}',
    '#hv-timer-flash {',
      'color: #ffcc00;',
      'font-weight: 900;',
      'text-shadow: 0 0 6px rgba(255,204,0,0.45);',
      'margin-right: 2px;',
    '}',
    '#hv-timer-message {',
      'font-size: 13.9px;',
      'font-weight: 700;',
      'color: #222222;',
      'letter-spacing: -0.01em;',
      'line-height: 1.2;',
      'white-space: nowrap;',
    '}',
    '#hv-timer-count-wrap {',
      'display: flex;',
      'flex-direction: column;',
      'align-items: flex-end;',
      'flex-shrink: 0;',
    '}',
    '#hv-timer-countdown {',
      'font-size: 26.7px;',
      'font-weight: 800;',
      'letter-spacing: 0.04em;',
      'font-variant-numeric: tabular-nums;',
      'color: #111111;',
      'line-height: 1;',
    '}',
    '#hv-timer-sub {',
      'font-size: 9.5px;',
      'letter-spacing: 0.1em;',
      'text-transform: uppercase;',
      'color: rgba(0,0,0,0.42);',
      'font-weight: 700;',
      'text-align: right;',
      'margin-top: 2px;',
    '}',
    '#hv-timer-track {',
      'height: 3px;',
      'background: rgba(0,0,0,0.11);',
      'border-radius: 99px;',
      'overflow: hidden;',
      'position: relative;',
      'z-index: 1;',
    '}',
    '#hv-timer-fill {',
      'height: 100%;',
      'width: 100%;',
      'border-radius: 99px;',
      'background: linear-gradient(90deg, rgba(0,96,57,0.35) 0%, #006039 100%);',
      'transition: width 1s linear, background 0.8s ease;',
    '}',
    '#hv-timer-wrap.hv-urgent #hv-timer-fill {',
      'background: linear-gradient(90deg, #ffcc00 0%, #ef4444 100%);',
    '}',
    '#hv-timer-wrap.hv-urgent #hv-timer-countdown {',
      'color: #b91c1c;',
    '}',
    '@media (prefers-reduced-motion: no-preference) {',
      '#hv-timer-wrap.hv-urgent #hv-timer-box {',
        'animation: hvPulse 2.5s ease-in-out infinite;',
      '}',
    '}',
    '@keyframes hvPulse {',
      '0%,100%{box-shadow:0 3px 14px rgba(0,0,0,0.08),inset 0 1px 0 rgba(255,255,255,0.9);}',
      '50%{box-shadow:0 3px 18px rgba(239,68,68,0.20),inset 0 1px 0 rgba(255,255,255,0.9);}',
    '}',
    '@media screen and (max-width: 749px) {',
      '#hv-good-choice {',
        'padding: 9px 18px;',
        'gap: 8px;',
      '}',
      '#hv-good-choice-icon {',
        'width: 20.9px;',
        'height: 20.9px;',
      '}',
      '#hv-good-choice-text {',
        'font-size: 14.3px;',
      '}',
      '#hv-guarantee-bar {',
        'padding: 6px 16px;',
        'gap: 7px;',
      '}',
      '#hv-guarantee-icon {',
        'width: 14px;',
        'height: 14px;',
      '}',
      '#hv-guarantee-text {',
        'font-size: 12.2px;',
      '}',
      '#hv-timer-wrap {',
        'width: calc(100% - 32px);',
        'margin: 5px 16px 15px;',
      '}',
      '#hv-timer-box {',
        'padding: 12px 14px 10px;',
      '}',
      '#hv-timer-countdown {',
        'font-size: 23.8px;',
      '}',
      '#hv-timer-message {',
        'font-size: 12.9px;',
      '}',
      '#hv-timer-eyebrow {',
        'font-size: 8.9px;',
      '}',
      '#hv-timer-sub {',
        'font-size: 9px;',
      '}',
    '}'
  ].join('');

  function safeGetStorage(key) {
    try {
      return sessionStorage.getItem(key);
    } catch (e) {
      return null;
    }
  }

  function safeSetStorage(key, value) {
    try {
      sessionStorage.setItem(key, value);
    } catch (e) {}
  }

  function safeRemoveStorage(key) {
    try {
      sessionStorage.removeItem(key);
    } catch (e) {}
  }

  function injectStyles() {
    if (document.getElementById('hv-timer-styles')) return;

    var s = document.createElement('style');
    s.id = 'hv-timer-styles';
    s.textContent = CSS;
    document.head.appendChild(s);
  }

  function getOrCreateExpiry() {
    var storedRaw = safeGetStorage(KEY);
    var stored = parseInt(storedRaw, 10);

    if (!isNaN(stored) && storedRaw) {
      return stored;
    }

    var expiry = Date.now() + DURATION;
    safeSetStorage(KEY, String(expiry));
    return expiry;
  }

  function buildGoodChoice() {
    var bar = document.createElement('div');
    bar.id = 'hv-good-choice';

    bar.innerHTML = [
      '<svg id="hv-good-choice-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">',
        '<path d="M12 2.5l1.4 3.8 3.8 1.4-3.8 1.4-1.4 3.8-1.4-3.8-3.8-1.4 3.8-1.4L12 2.5z" fill="white"/>',
        '<path d="M18.5 10.5l0.9 2.4 2.4 0.9-2.4 0.9-0.9 2.4-0.9-2.4-2.4-0.9 2.4-0.9 0.9-2.4z" fill="white" opacity="0.95"/>',
        '<path d="M6 13.5l1.1 3 3 1.1-3 1.1L6 21.5l-1.1-2.8-3-1.1 3-1.1L6 13.5z" fill="white" opacity="0.9"/>',
      '</svg>',
      '<span id="hv-good-choice-text">Schließe dich 30.000+ glücklichen Kunden an!</span>'
    ].join('');

    return bar;
  }

  function buildGuaranteeBar() {
    var bar = document.createElement('div');
    bar.id = 'hv-guarantee-bar';

    bar.innerHTML = [
      '<svg id="hv-guarantee-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">',
        '<path d="M12 2.5L19 5.2V10.8C19 15.25 16.15 18.8 12 21C7.85 18.8 5 15.25 5 10.8V5.2L12 2.5Z" fill="white"/>',
        '<path d="M10.7 13.9L8.75 11.95L7.7 13L10.7 16L16.3 10.4L15.25 9.35L10.7 13.9Z" fill="black"/>',
      '</svg>',
      '<span id="hv-guarantee-text">30 Tage Geld-zurück-Garantie</span>'
    ].join('');

    return bar;
  }

  function buildTimer() {
    var wrap = document.createElement('div');
    wrap.id = 'hv-timer-wrap';
    wrap.setAttribute('role', 'timer');
    wrap.setAttribute('aria-live', 'polite');

    wrap.innerHTML = [
      '<div id="hv-timer-box">',
        '<div id="hv-timer-row">',
          '<div id="hv-timer-texts">',
            '<span id="hv-timer-eyebrow"><span id="hv-timer-flash">&#9889;</span> Begrenzte Verf&uuml;gbarkeit</span>',
            '<span id="hv-timer-message">Warenkorb reserviert</span>',
          '</div>',
          '<div id="hv-timer-count-wrap">',
            '<span id="hv-timer-countdown">10:00</span>',
            '<span id="hv-timer-sub">verbleibend</span>',
          '</div>',
        '</div>',
        '<div id="hv-timer-track">',
          '<div id="hv-timer-fill"></div>',
        '</div>',
      '</div>'
    ].join('');

    return wrap;
  }

  function injectTimer() {
    if (document.getElementById('hv-timer-wrap')) return;

    var header = document.getElementById('cart-drawer-header');
    if (!header) return;

    if (!document.querySelector('cart-items-component .cart-form')) return;

    injectStyles();

    var oldGoodChoice = document.getElementById('hv-good-choice');
    if (oldGoodChoice) oldGoodChoice.remove();

    var oldGuarantee = document.getElementById('hv-guarantee-bar');
    if (oldGuarantee) oldGuarantee.remove();

    var guarantee = buildGuaranteeBar();
    var goodChoice = buildGoodChoice();
    var timer = buildTimer();

    header.insertAdjacentElement('afterend', timer);
    timer.insertAdjacentElement('beforebegin', goodChoice);
    goodChoice.insertAdjacentElement('beforebegin', guarantee);

    startTick();
  }

  function clearTick() {
    if (tickId) {
      clearTimeout(tickId);
      tickId = null;
    }
  }

  function updateTimer(expiry) {
    var wrap = document.getElementById('hv-timer-wrap');
    var count = document.getElementById('hv-timer-countdown');
    var fill = document.getElementById('hv-timer-fill');

    if (!wrap || !count || !fill) {
      clearTick();
      return false;
    }

    var remaining = expiry - Date.now();

    if (remaining <= 0) {
      count.textContent = '00:00';
      fill.style.width = '0%';
      wrap.classList.add('hv-urgent');
      clearTick();
      safeRemoveStorage(KEY);
      return false;
    }

    var s = Math.ceil(remaining / 1000);

    count.textContent =
      String(Math.floor(s / 60)).padStart(2, '0') + ':' +
      String(s % 60).padStart(2, '0');

    fill.style.width = Math.max(0, (remaining / DURATION) * 100) + '%';

    if (remaining <= 120000) {
      wrap.classList.add('hv-urgent');
    } else {
      wrap.classList.remove('hv-urgent');
    }

    return true;
  }

  function startTick() {
    clearTick();

    var expiry = getOrCreateExpiry();

    function tick() {
      if (document.hidden) {
        clearTick();
        return;
      }

      if (!updateTimer(expiry)) return;

      tickId = setTimeout(tick, 1000);
    }

    tick();
  }

  function scheduleInjectTimer() {
    if (injectScheduled) return;

    injectScheduled = true;

    requestAnimationFrame(function () {
      injectScheduled = false;
      injectTimer();
    });
  }

  function startObserver() {
    if (observer || !document.body) return;

    observer = new MutationObserver(function () {
      scheduleInjectTimer();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  document.addEventListener('visibilitychange', function () {
    if (document.hidden) {
      clearTick();
      return;
    }

    if (document.getElementById('hv-timer-wrap')) {
      startTick();
    } else {
      scheduleInjectTimer();
    }
  });

  function init() {
    injectTimer();
    startObserver();
  }

  if (document.readyState !== 'loading') {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }
})();